// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__1r2FY","description":"Gallery_description__1Hzlu"};